const { NODE_ENV } = process.env;

export const getIsProd = () => NODE_ENV === "production";
export const getIsDev = () => !getIsProd();
